import axios from 'axios';

import { request, parseError } from '../../helpers/requests';

export default {
  getTemplates: () => request({
    call: axios.get('/settings/projectBillingRateTemplates'),
    errMsg: "Could not get project billing rate templates",
    hideSuccessToast: true,
  }),
  getProjectRates: (projectId) => request({
    call: axios.get(`/projects/${projectId}/projectBillingRates`),
    errMsg: "Could not get project billing rates",
    hideSuccessToast: true,
  }),
  createTemplate: (payload) => request({
    call: axios.post('/settings/projectBillingRateTemplates', payload),
    errMsg: parseError('Could not create project billing rate template'),
    hideSuccessToast: true,
    suppressError: true,
  }),
  createProjectRates: (projectId, payload) => request({
    call: axios.post(`/projects/${projectId}/projectBillingRates`, payload),
    errMsg: parseError('Could not create project billing rate'),
    hideSuccessToast: true,
    suppressError: true,
  }),
  updateTemplate: (id, payload) => request({
    call: axios.put(`/settings/projectBillingRateTemplates/${id}`, payload),
    errMsg: parseError('Could not update project billing rate template'),
    hideSuccessToast: true,
    suppressError: true,
  }),
  updateProjectRate: (projectId, id, payload) => request({
    call: axios.put(`/projects/${projectId}/projectBillingRates/${id}`, payload),
    errMsg: parseError('Could not update project billing rate'),
    hideSuccessToast: true,
    suppressError: true,
  }),
  deleteTemplate: (id) => request({
    call: axios.delete(`/settings/projectBillingRateTemplates/${id}`),
    errMsg: "Could not delete project billing rate template",
  }),
  deleteProjectRate: (projectId, id) => request({
    call: axios.delete(`/projects/${projectId}/projectBillingRates/${id}`),
    errMsg: "Could not delete project billing rate",
  }),
};